import MessageFormValidate from "components/shared-components/MessageFormValidate";
import UploadForm from "components/shared-components/UploadForm";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  resetUploadAttackFileInvoicePos,
  uploadAttackFileInvoicePos,
} from "store/actions";

const ConfirmCancelInvoiceModal = props => {
  const {
    isOpen,
    toggle,
    titleHeader,
    titleBody,
    isHaveNote,
    notePlateHolder,
    textBtnCancel,
    textBtnConfirm,
    onConfirm,
    isDisableButton,
    isRequireNote,
    isShowAttacksFile,
  } = props;

  const [isError, setIsError] = useState(false);
  const { t } = useTranslation("common");
  const inputArea = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setListUploadFile([]);
    }
  }, [isOpen]);

  const dispatch = useDispatch();

  const handleFiles = (files, uploadType = "") => {
    if (files.length > 0) {
      for (const item of files) {
        const bodyFormData = new FormData();
        bodyFormData.append("file", item);
        dispatch(uploadAttackFileInvoicePos(bodyFormData, uploadType));
      }
    }
  };

  const invoicePos = useSelector(state => state.invoicePos);
  const { uploadFile, loadingUploadFile } = invoicePos;

  const [listUploadFile, setListUploadFile] = useState([]);
  // Action Dispatch
  useEffect(() => {
    if (uploadFile && uploadFile.success) {
      setListUploadFile([
        ...listUploadFile,
        { id: uploadFile.id, file_name: "" },
      ]);
      dispatch(resetUploadAttackFileInvoicePos());
    }
    // console.log("error", errors);
  }, [uploadFile]);

  return (
    <Modal
      size="lg"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>{titleHeader}</ModalHeader>
        {(titleBody || isHaveNote) && (
          <ModalBody>
            <span style={{ fontSize: "15px" }}>{titleBody}</span>
            {isHaveNote && (
              <React.Fragment>
                <textarea
                  className={
                    `form-control mt-3 ` + (isError ? "is-invalid" : "")
                  }
                  ref={inputArea}
                  id="commentmessage-input"
                  placeholder={notePlateHolder}
                  rows="3"
                ></textarea>
                {isError && (
                  <MessageFormValidate
                    error={`${t("requiredInput")} ${titleBody}`}
                  />
                )}
                {isShowAttacksFile && (
                  <React.Fragment>
                    <div className="custom-form-heading  mt-3">
                      <i className="fas fa-paperclip text-primary"></i>
                      <strong>BIÊN BẢN ĐÍNH KÈM</strong>
                    </div>
                    <Row>
                      <Col>
                        <UploadForm
                          multiple={true}
                          handleFiles={files => handleFiles(files)}
                          accept=".doc,.docx,.pdf"
                          removeFile={(a, index) => {
                            listUploadFile.splice(index, 1);
                            setListUploadFile(listUploadFile);
                          }}
                        ></UploadForm>
                      </Col>
                    </Row>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </ModalBody>
        )}
        <ModalFooter>
          <Button
            type="button"
            color="danger"
            disabled={isDisableButton}
            className="me-2 btn-label"
            onClick={toggle}
          >
            <i className="bx bx-x label-icon" />
            {textBtnCancel ? textBtnCancel : "Bỏ qua"}
          </Button>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={isDisableButton || loadingUploadFile}
            onClick={() => {
              if (inputArea.current) {
                if (isRequireNote) {
                  if (inputArea.current.value.trim() === "") {
                    setIsError(true);
                  } else {
                    setIsError(false);
                    onConfirm &&
                      onConfirm(
                        inputArea.current.value,
                        listUploadFile.map(item => item.id)
                      );
                  }
                } else {
                  onConfirm &&
                    onConfirm(
                      inputArea.current.value,
                      listUploadFile.map(item => item.id)
                    );
                }
              } else {
                onConfirm &&
                  onConfirm(
                    null,
                    listUploadFile.map(item => item.id)
                  );
              }
            }}
          >
            <i className="bx bx-check label-icon" />
            {textBtnConfirm ? textBtnConfirm : "Đồng ý"}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

ConfirmCancelInvoiceModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  isHaveNote: PropTypes.bool,
  isRequireNote: PropTypes.bool,
  titleHeader: PropTypes.string,
  titleBody: PropTypes.string,
  textBtnCancel: PropTypes.string,
  textBtnConfirm: PropTypes.string,
  notePlateHolder: PropTypes.string,
  isDisableButton: PropTypes.bool,
  isShowAttacksFile: PropTypes.bool,
  onConfirm: PropTypes.func,
};

ConfirmCancelInvoiceModal.defaultProps = {
  isDisableButton: false,
  isRequireNote: true,
  isShowAttacksFile: false,
};

export default ConfirmCancelInvoiceModal;
